<template>
	<div @click="toDetail" class="c-office flex flex-align-center">
		<div class="c-officeImg">
			<img :src="info.pic" alt="">
		</div>
		<div class="flex-1 flex flex-column" style="width: 25px">
			<div class="c-office-name no-wrap">{{info.title}}</div>
			<div class="c-office-time flex flex-align-center">
				<img src="@/static/images/my/time.png" alt="">
				<!-- <div class="no-wrap">18：00-21：30</div> -->
				<div class="no-wrap">{{info.work_time}}</div>
			</div>
			<div class="c-office-location flex flex-align-center">
				<img src="@/static/images/my/location.png" alt="">
				<div class="no-wrap">
					<span>{{info.distance | distance}} | </span>
					<span>
						{{info.address}}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/* eslint-disable */
	export default {
		watch: {
		},
		props: {
			info: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: [Number, String],
				default: 1
			}
		},
		filters: {
			distance(val) {
				if (val*1 < 1000) {
					return val*1 + 'm'
				} else {
					return (val / 1000).toFixed(2) + 'km'
				}
			}
		},
		data() {
			return{

			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			toDetail() {
				if (this.type == 1) {
					this.$router.push(`/home/office/details?id=${this.info.id}`)
				} else if (this.type == 2) {
					this.$router.push(`/home/resources/officeDetail?id=${this.info.id}`)
				}
			}
		}
	}
</script>

<style scoped lang="stylus">
.c-office
	margin-bottom 28px
	.c-officeImg
		width: 136px;
		height: 136px;
		background: rgba(0, 0, 0, 0);
		border-radius: 20px;
		margin-right 24px
		img
			width 100%
			height 100%
			border-radius: 20px;
	.c-office-name
		width: 100%
		height: 42px;
		font-size: 30px;
		font-weight: bold;
		color: #111111;
		margin-bottom 15px
	.c-office-time
		font-size: 26px;
		color: #B1B1B1;
		margin-bottom 8px
		img
			width 26px
			height 26px
			margin-right 12px
	.c-office-location
		font-size: 26px;
		color: #B1B1B1;
		img
			width 21px
			height 26px
			margin-right 18px
</style>
